import { useTaskService } from 'hooks/services/use-task-service';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { ComponentLoader } from 'views/Member/components/ComponentLoader';

const Task: React.VFC = () => {
  const taskService = useTaskService();
  const navigate = useNavigate();
  const location = useLocation();

  let taskId: string | null = location?.state?.paramsData?.taskId;

  useEffect(() => {
    try {
      if (!taskId) {
        navigate('/dashboard', { replace: true });
      } else {
        taskService.getLinkedTask(taskId).then((t) => {
          navigate(`/member`, {
            state: {
              paramsData: {
                taskId: t.taskId,
                memberId: t.memberId
              }
            }
          });
        });
      }
    } catch (err) {
      navigate('/dashboard', { replace: true });
    }
  }, [taskId]);

  return <ComponentLoader isLoading={true} />;
};

export default Task;
